import { Button, Clickable, Col, Icon, Row, Spinner, Text } from 'components';
import { addMinutes, subMinutes } from 'date-fns';
import { theme } from 'lib';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ConnectRequest = ({ data }) => {
  const [loading, setLoading] = useState(false),
    { sender, type, timestamp, entityId, connect } = data,
    user = useSelector((state) => state.user),
    navigate = useNavigate(),
    { t } = useTranslation();

  const connectData = useSelector((state) => state.connects.find((x) => x._id === entityId));

  if (!connect) return null;

  const canCancel = new Date(connect.date) > new Date() && connectData?.status !== 'canceled',
    canBookAgain = ['rejected', 'canceled', 'completed'].includes(connect.status),
    happeningNow =
      addMinutes(new Date(), 15) > new Date(data.date) &&
      new Date() > subMinutes(new Date(data.date), 1);

  if (!sender) return null;

  function getValues() {
    switch (type) {
      case 'connectConfirm':
        return ['scheduleAvailable', t('common.confirmed')];

      case 'connectRefuse':
        return ['scheduleCancelled', t('common.refused')];

      case 'connectPending':
        return ['schedulePending', t('common.pending')];

      case 'connectCancel':
        return ['scheduleCancelled', t('common.canceled')];

      case 'connectStart':
        return ['scheduleAvailable', t('common.canceled')];

      default:
    }
  }

  function bookAgain() {}

  function cancel() {}

  function handleNavigation() {
    switch (true) {
      case type === 'connectStart' && happeningNow:
        break;

      case user.type === 'fan':
        break;

      case user.type === 'athlete':
        break;

      default:
    }
  }

  return (
    <Clickable onClick={handleNavigation}>
      <Col
        noFlex
        pad="11px 16px 16px 18px"
        marg="0 0 12px"
        bg={type === 'connectStart' ? theme.DARK_BLUE : theme.GREY_10}
      >
        <Row noFlex marg="0 0 12px">
          <Icon
            type={getValues()[0]}
            dimensions={24}
            marg="10px 0 0 2px"
            col={type === 'connectStart' ? '#fff' : theme.GREY_50}
          />

          <Row wid="100%" between marg="4px 0 0 12px">
            {type === 'connectStart' ? (
              <Col noFlex wid="75%">
                <Text col="#fff" lineHt="21.5px">
                  <Trans>{t('notifications.connectStarting', { sender: sender.name })}</Trans>
                </Text>
              </Col>
            ) : (
              <Col noFlex wid="75%" marg="1.5px 0 0">
                <Text lineHt="21.5px">
                  <Trans>
                    {t('notifications.connectStatus', {
                      status: getValues()[1],
                      sender: sender.name || sender.username
                    })}
                  </Trans>
                </Text>
              </Col>
            )}

            <Text b2 med col={type === 'connectStart' ? '#fff' : theme.GREY_60} marg="3px 0 0">
              {timestamp}
            </Text>
          </Row>
        </Row>

        {loading && (
          <Row centerAll marg="12px 0 0" ht="30px">
            <Spinner />
          </Row>
        )}

        {canCancel && user.type === 'athlete' ? (
          <Button
            text={t('common.cancel')}
            wid="fit-content"
            pad="0 20px"
            app
            small
            bordered
            onClick={cancel}
            reverse={type === 'connectStart'}
          />
        ) : (
          canCancel &&
          user.type !== 'athlete' && (
            <Button
              text={canBookAgain ? t('connectsDashboard.bookAgain') : t('common.cancel')}
              wid="fit-content"
              pad="14px 18px"
              app
              small
              bordered
              onClick={canBookAgain ? bookAgain : cancel}
              reverse={type === 'connectStart'}
            />
          )
        )}
      </Col>
    </Clickable>
  );
};

export default ConnectRequest;
